import React from "react";
import { useTranslation } from "react-i18next";

interface AddButtonProps {
  onAddVenue: () => void;
  onAddGear: () => void;
  hasExistingGear?: boolean;
}

const AddButton = ({
  onAddVenue,
  onAddGear,
  hasExistingGear = false,
}: AddButtonProps) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-3 mt-2 mb-4">
      <button
        onClick={onAddVenue}
        className="w-full h-[42px] bg-[#5A18C4] hover:bg-[#5A18C4]/80 text-white rounded-pill border border-[#8200DB] flex items-center justify-center gap-2 text-[14px] font-medium transition-all hover:scale-[1.02]"
      >
        <span>{t("forms.addVenue", "Aggiungi Locale")}</span>
      </button>

      <button
        onClick={onAddGear}
        className="w-full h-[42px] rounded-pill flex items-center justify-center gap-2 text-[14px] font-medium transition-all bg-secondary hover:bg-secondary-600 text-white hover:scale-[1.02]"
      >
        <span>
          {hasExistingGear
            ? t("forms.addItemButton", "Aggiungi Articolo")
            : t("forms.addGear", "Aggiungi GearPal")}
        </span>
      </button>
    </div>
  );
};

export default AddButton;
